var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.848,
    height: 20.17,
    viewBox: "0 0 22.848 20.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like",
    transform: "translate(0 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16961",
    "data-name": "Group 16961",
    transform: "translate(0 30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8315",
    "data-name": "Path 8315",
    d: "M16.779,30A5.409,5.409,0,0,0,13.4,31.168a7.7,7.7,0,0,0-1.977,2.377,7.7,7.7,0,0,0-1.977-2.377A5.409,5.409,0,0,0,6.069,30C2.609,30,0,32.83,0,36.583c0,4.054,3.255,6.828,8.183,11.027.837.713,1.785,1.521,2.771,2.384a.714.714,0,0,0,.94,0c.986-.862,1.934-1.671,2.772-2.384,4.927-4.2,8.182-6.973,8.182-11.027C22.848,32.83,20.239,30,16.779,30Z",
    transform: "translate(0 -30)",
    fill: "#f9b316"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowHeart);
export default __webpack_public_path__ + "static/media/yellow_heart.a5797932ac945746f8f3bcc1c5aa7b5b.svg";
export { ForwardRef as ReactComponent };